const LogoMark = ({ className = "h-10" }) => (
  <img
    src="/images/engine-logo.png"
    alt="Dreamworlds Garage engine mark"
    className={`${className} w-auto`}
    draggable="false"
  />
);

export default LogoMark;
